<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" :viewBox="viewBox">
    <defs>
      <linearGradient id="a" x1="58.871%" x2="41.048%" y1="75.795%" y2="3.044%">
        <stop offset="0%" stop-color="#3DD5D3" />
        <stop offset="100%" stop-color="#3DFFD3" />
      </linearGradient>
      <linearGradient id="b" x1="71.841%" x2="13.45%" y1="81.182%" y2="-3.037%">
        <stop offset="34.42%" stop-color="#2A7CBF" />
        <stop offset="84.27%" stop-color="#49C3DD" />
      </linearGradient>
      <linearGradient id="c" x1="62.959%" x2="-11.608%" y1="59.409%" y2="6.219%">
        <stop offset="0%" stop-color="#2A7CBF" />
        <stop offset="67.97%" stop-color="#49C3DD" />
      </linearGradient>
      <linearGradient id="d" x1="0%" x2="73.783%" y1="49.997%" y2="49.997%">
        <stop offset="0%" stop-color="#3DD5D3" />
        <stop offset="100%" stop-color="#3DFFD3" />
      </linearGradient>
    </defs>
    <g fill="none" fill-rule="nonzero">
      <path
        fill="url(#a)"
        d="M81.996 27.87C76.806 12.745 65.998 5.155 56.75 2.013 40.598-3.478 27.558 3.905 26 4.843c.091-.015.183-.027.276-.04.114-.017.229-.036.342-.06 1.576-.34 5.47-.888 10.833.35C52.753 8.187 64.3 22.122 64.3 38.846c0 11.844-5.793 22.289-14.606 28.476-.177.124-3.089 1.772-6.393 3.235-.121.054-1.079.642-1.179.732-4.475 4 6.437 8.185 12.033 6.205 7.62-2.698 15.297-5.433 19.112-9.376C83.882 57.14 86.262 40.303 81.996 27.87z"
      />
      <path
        fill="url(#b)"
        d="M44.053 56.865a19.789 19.789 0 0 1-4.94-.63l-1.768-.459-8.925 7.712a10.492 10.492 0 0 1-7.915 2.538c-2.892-.273-5.5-1.687-7.341-3.982-1.841-2.293-2.71-5.21-2.448-8.21.264-3 1.627-5.707 3.839-7.616l11.233-9.706a10.55 10.55 0 0 1 6.923-2.597c3.108 0 6.192 1.376 8.332 4.04 1.546 1.927 2.396 4.293 2.476 6.778a7.961 7.961 0 0 0 5.255-1.516L50 42.329a18.36 18.36 0 0 0-3.835-8.8c-6.175-7.692-17.232-8.739-24.646-2.333l-11.233 9.706c-3.58 3.093-5.786 7.463-6.211 12.303-.426 4.84.981 9.552 3.964 13.266C11.496 70.776 16.48 73 21.499 73c3.95 0 7.92-1.376 11.185-4.197l11.233-9.706a17.873 17.873 0 0 0 2.26-2.355c-.706.079-1.416.123-2.124.123z"
      />
      <path
        fill="url(#c)"
        d="M68.955 14.523c-2.98-3.715-7.193-6.005-11.859-6.447-4.666-.437-9.206 1.02-12.785 4.114L33.079 21.9a17.841 17.841 0 0 0-2.259 2.352 19.462 19.462 0 0 1 7.073.51l1.76.46 8.923-7.716c1.952-1.687 4.37-2.589 6.9-2.589.337 0 .674.017 1.014.05 2.892.272 5.5 1.687 7.34 3.981 1.841 2.296 2.71 5.213 2.447 8.215-.263 3.001-1.626 5.707-3.836 7.619L51.209 44.49c-2.211 1.91-5.023 2.812-7.912 2.54-2.892-.274-5.5-1.689-7.34-3.983-1.596-1.989-2.406-4.386-2.487-6.79l-.169-.011c-.106-.008-.214-.018-.32-.018-1.711 0-3.355.535-4.754 1.55l-1.227.89a18.372 18.372 0 0 0 3.835 8.808c2.98 3.715 7.193 6.004 11.859 6.446.545.05 1.09.077 1.63.077 4.084 0 7.994-1.46 11.155-4.19l11.232-9.71c7.411-6.408 8.418-17.882 2.244-25.577z"
      />
      <path
        fill="url(#d)"
        d="M71.943 69.395c-13.34 10.704-26.62 1.289-31.225-2.76l6.937-2.087c.089-.036.093-.163.006-.204L12.82 46.011a.107.107 0 0 0-.15.066C12.072 48.03 2.4 70.61.005 78.714a.11.11 0 0 0 .145.134l7.893-2.375c13.712 7.287 31.837 7.784 43.445 4.846 14.786-3.742 21.191-12.514 20.455-11.924z"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-logo-image',
    props: {
      width: {
        type: [Number, String],
        default: 84
      },
      height: {
        type: [Number, String],
        default: 83
      },
      viewBox: {
        type: String,
        default: '0 0 84 83'
      }
    }
  };
</script>
